'use client';

import { Card, CardBody, CardHeader, DateInput } from '@hc-frontend/core-ui';
import { getISODate } from '@hc-frontend/core-utils-date';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { ClearFiltersLink } from '../../atoms/clear-filters-link';
import type { EffectiveDateFilterProps } from './effective-date-filter.types';

export function EffectiveDateFilter({
  effectiveDateFilterGroup,
}: EffectiveDateFilterProps) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const defaultValue = effectiveDateFilterGroup.items[0].value;

  const getInitialValue = () => {
    const params = new URLSearchParams(searchParams.toString());
    const dateParam = params.get(effectiveDateFilterGroup.key);

    if (dateParam) {
      const date = new Date();
      const [year, month, day] = dateParam.split('-');
      date.setFullYear(parseInt(year, 10));
      date.setMonth(parseInt(month, 10) - 1);
      date.setDate(parseInt(day, 10));
      return date;
    }

    return defaultValue;
  };

  const onDateChange = (date: Date) => {
    const dateString = getISODate(date) as string;

    const params = new URLSearchParams(searchParams.toString());
    params.set(effectiveDateFilterGroup.key, dateString);
    router.replace(`${pathname}?${params.toString()}`);
  };

  return (
    <Card className="w-full">
      <CardHeader className="relative">
        <p className="hc-typography--heading-four font-semibold">
          {effectiveDateFilterGroup.title}
        </p>
        <ClearFiltersLink
          id="clear-effective-date-filter"
          className="absolute right-16-16 top-1/2 -translate-y-1/2"
          filterKeys={[effectiveDateFilterGroup.key]}
          text="Reset"
        />
      </CardHeader>
      <CardBody className="hc-stack-layout--large px-12-24 py-16-16">
        <DateInput
          initialValue={getInitialValue()}
          onChange={onDateChange}
          id="effective-date"
          name="Effective date"
          className="mb-12-12 max-w-full"
        />
      </CardBody>
    </Card>
  );
}
